import {defineStore} from "pinia";
import storage from "@/utils/storage";
import router from "@/router";
import dynamic from "@/router/openTreeToArray";
import request from "@/request";
import tabsStore from "@/store/modules/tabs";
import {ElMessage} from "element-plus";


/**
 * @description: 用于用户数据
 */
const userStore = defineStore("user", {
    state: () => ({
        /**
         * token
         */
        token: storage.get("token"),
        /**
         * 用户信息
         */
        info: {},
        /**
         * 用户拥有的角色
         */
        roles: [],
        /**
         * 用户拥有的权限
         */
        permissions: [],
        /**
         * 初始化路由标记
         */
        initRouter: false,
        /**
         * 路由
         */
        router: [],
    }),
    actions: {
        /**
         * @description: 保存token
         * @param token
         */
        saveToken(token) {
            storage.set("token", token);
            this.token = token;
        },
        /**
         * @description: 保存用户信息 角色以及权限数据
         * @param data
         */
        saveUserInfoRolesPermissions(data) {
            this.info = data.user;
            this.roles = data.roles;
            this.permissions = data.permissions;
        },
        /**
         * @description: 保存路由
         * @param data
         */
        saveRouter(data) {
            this.router = data;
            // 动态配置路由
            dynamic.appendDynamicRoutes(data);
        },
        /**
         * @description: 退出登录
         */
        async logout(remote = true) {
            try {
                if (remote) {
                    const res = await request.post("/auth/logout");
                    if (res && res.code === 0) {
                        ElMessage.success("退出登录成功");
                    } else {
                        ElMessage.warning(res?.msg || "退出接口请求失败，已清除本地登录状态");
                    }
                }
            } catch (error) {
                if (remote) {
                    ElMessage.warning("退出接口请求失败，已清除本地登录状态");
                }
            } finally {
                storage.clearAll();
                dynamic.clearDynamicRoutes();
                this.$reset();
                tabsStore().$reset();
                await router.replace("/login");
            }
        },
        /**
         * @description: 获取用户信息
         * @returns {Promise<void>}
         */
        async getMenu() {
            let res = await request.get("menu");
            userStore().saveRouter(res.data);
        }
    }

})


export default userStore
